import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { BsPersonFill, BsThreeDots, BsSearch } from "react-icons/bs";
import { BiVideoPlus } from "react-icons/bi";
import avater from "assets/images/avatar.png";

const RightSidebar = () => {
  return (
    <Container className=" flex-1 bg-gray-900 overflow-x-hidden overflow-y-auto">
      <div className="flex justify-between">
        <div className="text-gray-400 text-base font-medium p-2">
          {" "}
          <span>Contacts</span>{" "}
        </div>
        <div className="flex justify-end items-center">
          {iconsListItems?.map((item, index) => (
            <span
              key={index}
              className="text-base text-gray-400 p-2 mr-1 cursor-pointer hover:bg-gray-700 hover:text-gray-300 rounded-md"
            >
              {item.icon}
            </span>
          ))}
        </div>
      </div>
      <div>
        <ul>
          {activepersonListItems?.map((item, index) => (
            <li key={index}>
              <div className="flex justify-start items-center  p-2 m-2 rounded-lg group hover:bg-gray-600 cursor-pointer">
                <img
                  className="h-8 w-8 mr-3 object-contain rounded-full cursor-pointer"
                  src={avater}
                />
                <span className="text-gray-500 text-base font-medium  group-hover:text-gray-400">
                  {item?.name}
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </Container>
  );
};

export default RightSidebar;

const Container = styled.div`
  height: calc(100vh - 80px) !important;
  position: sticky !important;
  top: 80px !important;
  margin-right: -100%;
  display: none;

  @media (min-width: 768px) {
    margin-right: 0%;
    display: block;
  }
  ${tw``}
`;

const activepersonListItems = [
  { name: "Jhon Wick", icon: <BsPersonFill /> },
  { name: "Jhon Wick", icon: <BsPersonFill /> },
  { name: "Jhon Wick", icon: <BsPersonFill /> },
  { name: "Jhon Wick", icon: <BsPersonFill /> },
  { name: "Jhon Wick", icon: <BsPersonFill /> },
  { name: "Jhon Wick", icon: <BsPersonFill /> },
  { name: "Jhon Wick", icon: <BsPersonFill /> },
  { name: "Jhon Wick", icon: <BsPersonFill /> },
  { name: "Jhon Wick", icon: <BsPersonFill /> },
];

const iconsListItems = [
  { icon: <BiVideoPlus /> },
  { icon: <BsSearch /> },
  { icon: <BsThreeDots /> },
];
